AFRAME.registerComponent('right-panel-expand', {
    init: function () {
        console.log('right-panel-expand: Initializing');
        this.isExpanded = false;
        this.rightContainerOriginalState = null;
        this.lastArrowClickTime = 0;
        this.arrowClickThrottleTime = 1000;

        this.setupArrowClickHandlers();
    },

    expand: function (onComplete) {
        console.log('right-panel-expand: Expanding panel');

        const rightContainer = this.el;

        const fixedCenterX = 0;
        const fixedCenterY = 2.2;
        const fixedCenterZ = -1.2;

        const pRX = rightContainer.object3D.position.x;
        const pRY = rightContainer.object3D.position.y;
        const pRZ = rightContainer.object3D.position.z;

        const distanceFromCenter = Math.sqrt(
            Math.pow(pRX - fixedCenterX, 2) +
            Math.pow(pRY - fixedCenterY, 2) +
            Math.pow(pRZ - fixedCenterZ, 2)
        );

        const tolerance = 0.5;
        const isInCenter = distanceFromCenter < tolerance;

        if (!this.rightContainerOriginalState) {
            const currentScale = rightContainer.getAttribute('scale');
            const currentRot = rightContainer.getAttribute('rotation');

            let scaleX, scaleY, scaleZ;
            if (typeof currentScale === 'string') {
                const scaleParts = currentScale.split(' ').map(p => parseFloat(p));
                scaleX = scaleParts[0] || 5.6;
                scaleY = scaleParts[1] || 3.6;
                scaleZ = scaleParts[2] || 1;
            } else {
                scaleX = parseFloat(currentScale?.x) || 5.6;
                scaleY = parseFloat(currentScale?.y) || 3.6;
                scaleZ = parseFloat(currentScale?.z) || 1;
            }

            let rotX, rotY, rotZ;
            if (typeof currentRot === 'string') {
                const rotParts = currentRot.split(' ').map(p => parseFloat(p));
                rotX = rotParts[0] || 0;
                rotY = rotParts[1] || -45;
                rotZ = rotParts[2] || 0;
            } else {
                rotX = parseFloat(currentRot?.x) || 0;
                rotY = parseFloat(currentRot?.y) || -45;
                rotZ = parseFloat(currentRot?.z) || 0;
            }

            this.rightContainerOriginalState = {
                position: { x: pRX, y: pRY, z: pRZ },
                scale: { x: scaleX, y: scaleY, z: scaleZ },
                rotation: { x: rotX, y: rotY, z: rotZ }
            };
        }

        const baseScaleZ = this.rightContainerOriginalState.scale.z;
        const expandedScale = { x: 8, y: 8, z: baseScaleZ };

        if (isInCenter) {
            rightContainer.removeAttribute('animation__expand');
            rightContainer.removeAttribute('animation__collapse');
            rightContainer.setAttribute('animation__expand', {
                property: 'scale',
                to: `${expandedScale.x} ${expandedScale.y} ${expandedScale.z}`,
                dur: 600,
                easing: 'easeInOutCubic'
            });

            setTimeout(() => {
                if (typeof onComplete === 'function') onComplete();
                this.isExpanded = true;
            }, 650);
            return;
        }

        const mainElementsMovingEl = document.querySelector('[main-elements-moving]');
        if (mainElementsMovingEl && mainElementsMovingEl.components && mainElementsMovingEl.components['main-elements-moving']) {
            const mainElementsMoving = mainElementsMovingEl.components['main-elements-moving'];
            const originalCheck = mainElementsMoving.checkIfChartNotBlocked;
            const originalLastClickTime = mainElementsMoving.lastClickTime;
            mainElementsMoving.checkIfChartNotBlocked = () => false;
            mainElementsMoving.lastClickTime = 0;

            const isOnLeft = pRX < fixedCenterX - 0.5;
            const isOnRight = pRX > fixedCenterX + 0.5;

            if (isOnLeft) {
                mainElementsMoving.handleClickOnArrow(true);
            } else if (isOnRight) {
                mainElementsMoving.handleClickOnArrow(false);
            } else {
                mainElementsMoving.handleClickOnArrow(false);
            }

            mainElementsMoving.checkIfChartNotBlocked = originalCheck;
            mainElementsMoving.lastClickTime = originalLastClickTime;
        }

        rightContainer.removeAttribute('animation__expand');
        rightContainer.removeAttribute('animation__collapse');
        rightContainer.setAttribute('animation__expand', {
            property: 'scale',
            to: `${expandedScale.x} ${expandedScale.y} ${expandedScale.z}`,
            dur: 600,
            easing: 'easeInOutCubic'
        });

        setTimeout(() => {
            if (typeof onComplete === 'function') onComplete();
            this.isExpanded = true;
        }, 650);
    },

    collapse: function (onComplete) {
        console.log('right-panel-expand: Collapsing panel');

        if (!this.isExpanded || !this.rightContainerOriginalState) return;

        if (typeof onComplete === 'function') onComplete();

        const rightContainer = this.el;

        const mainElementsMovingEl = document.querySelector('[main-elements-moving]');
        if (mainElementsMovingEl && mainElementsMovingEl.components && mainElementsMovingEl.components['main-elements-moving']) {
            const mainElementsMoving = mainElementsMovingEl.components['main-elements-moving'];
            const currentStep = mainElementsMoving.data.currentStep;

            if (currentStep === 1) {
                const originalCheck = mainElementsMoving.checkIfChartNotBlocked;
                const originalLastClickTime = mainElementsMoving.lastClickTime;
                mainElementsMoving.checkIfChartNotBlocked = () => false;
                mainElementsMoving.lastClickTime = 0;

                mainElementsMoving.handleClickOnArrow(false);

                mainElementsMoving.checkIfChartNotBlocked = originalCheck;
                mainElementsMoving.lastClickTime = originalLastClickTime;
            }
        }

        const orig = this.rightContainerOriginalState;
        rightContainer.removeAttribute('animation__expand');
        rightContainer.removeAttribute('animation__collapse');

        rightContainer.setAttribute('animation__collapse', {
            property: 'scale',
            to: `${orig.scale.x} ${orig.scale.y} ${orig.scale.z}`,
            dur: 600,
            easing: 'easeInOutCubic'
        });

        setTimeout(() => {
            const currentPos = rightContainer.getAttribute('position');
            const currentScale = rightContainer.getAttribute('scale');
            const currentRot = rightContainer.getAttribute('rotation');

            let posX, posY, posZ;
            if (typeof currentPos === 'string') {
                const parts = currentPos.split(' ').map(p => parseFloat(p));
                posX = parts[0] || 0.8;
                posY = parts[1] || 2.2;
                posZ = parts[2] || -2.5;
            } else {
                posX = parseFloat(currentPos?.x) || 0.8;
                posY = parseFloat(currentPos?.y) || 2.2;
                posZ = parseFloat(currentPos?.z) || -2.5;
            }

            let scaleX, scaleY, scaleZ;
            if (typeof currentScale === 'string') {
                const parts = currentScale.split(' ').map(s => parseFloat(s));
                scaleX = parts[0] || 1;
                scaleY = parts[1] || 1;
                scaleZ = parts[2] || 1;
            } else {
                scaleX = parseFloat(currentScale?.x) || 1;
                scaleY = parseFloat(currentScale?.y) || 1;
                scaleZ = parseFloat(currentScale?.z) || 1;
            }

            let rotX, rotY, rotZ;
            if (typeof currentRot === 'string') {
                const parts = currentRot.split(' ').map(r => parseFloat(r));
                rotX = parts[0] || 0;
                rotY = parts[1] || 0;
                rotZ = parts[2] || 0;
            } else {
                rotX = parseFloat(currentRot?.x) || 0;
                rotY = parseFloat(currentRot?.y) || 0;
                rotZ = parseFloat(currentRot?.z) || 0;
            }

            this.rightContainerOriginalState = {
                position: { x: posX, y: posY, z: posZ },
                scale: { x: scaleX, y: scaleY, z: scaleZ },
                rotation: { x: rotX, y: rotY, z: rotZ }
            };
        }, 650);

        this.isExpanded = false;
    },

    setupArrowClickHandlers: function () {
        const self = this;

        const rightArrow = document.querySelector('#right-triangle-arrow-model');
        const leftArrow = document.querySelector('#left-triangle-arrow-model');

        if (rightArrow && leftArrow) {
            const isRightPanelInCenter = () => {
                const rightPanel = document.getElementById('right-container');
                const leftPanel = document.getElementById('left-panel-2');
                const centerPanel = document.getElementById('large-center-panel');

                if (!rightPanel || !leftPanel || !centerPanel) return false;

                const { x: pRX, y: pRY, z: pRZ } = rightPanel.object3D.position;
                const { x: pCX, y: pCY, z: pCZ } = centerPanel.object3D.position;

                const centerY = pCY + 0.6;
                const tolerance = 0.2;
                return Math.abs(pRY - centerY) < tolerance &&
                    Math.abs(pRX - pCX) < tolerance &&
                    Math.abs(pRZ - pCZ) < tolerance;
            };

            rightArrow.addEventListener('click', function (event) {
                const rightInCenter = isRightPanelInCenter();

                if (self.isExpanded) {
                    event.stopImmediatePropagation();

                    let activeCallback = null;
                    const financialsTab = document.querySelector('.financials-tab');
                    const profileTab = document.querySelector('.profile-tab');

                    if (financialsTab && financialsTab.components && financialsTab.components['financials-tab'] && financialsTab.components['financials-tab'].isExpanded) {
                        activeCallback = () => financialsTab.components['financials-tab'].hideFinancialsTable();
                    } else if (profileTab && profileTab.components && profileTab.components['profile-tab'] && profileTab.components['profile-tab'].isExpanded) {
                        activeCallback = () => profileTab.components['profile-tab'].hideExpandedDescription();
                    }

                    self.collapse(activeCallback);

                    setTimeout(() => {
                        if (!isRightPanelInCenter()) {
                            const mainElementsMovingEl = document.querySelector('[main-elements-moving]');
                            if (mainElementsMovingEl && mainElementsMovingEl.components && mainElementsMovingEl.components['main-elements-moving']) {
                                const mainElementsMoving = mainElementsMovingEl.components['main-elements-moving'];
                                const originalCheck = mainElementsMoving.checkIfChartNotBlocked;
                                const originalLastClickTime = mainElementsMoving.lastClickTime;
                                mainElementsMoving.checkIfChartNotBlocked = () => false;
                                mainElementsMoving.lastClickTime = 0;
                                mainElementsMoving.handleClickOnArrow(true);
                                mainElementsMoving.checkIfChartNotBlocked = originalCheck;
                                mainElementsMoving.lastClickTime = originalLastClickTime;
                            }
                        }
                    }, 650);
                } else if (rightInCenter) {
                    const now = Date.now();
                    const timeSinceLastClick = now - self.lastArrowClickTime;
                    if (timeSinceLastClick < self.arrowClickThrottleTime) {
                        event.stopImmediatePropagation();
                        event.preventDefault();
                        return;
                    }
                    self.lastArrowClickTime = now;
                }
            }, true);

            leftArrow.addEventListener('click', function (event) {
                const rightInCenter = isRightPanelInCenter();

                if (self.isExpanded) {
                    event.stopImmediatePropagation();

                    let activeCallback = null;
                    const financialsTab = document.querySelector('.financials-tab');
                    const profileTab = document.querySelector('.profile-tab');

                    if (financialsTab && financialsTab.components && financialsTab.components['financials-tab'] && financialsTab.components['financials-tab'].isExpanded) {
                        activeCallback = () => financialsTab.components['financials-tab'].hideFinancialsTable();
                    } else if (profileTab && profileTab.components && profileTab.components['profile-tab'] && profileTab.components['profile-tab'].isExpanded) {
                        activeCallback = () => profileTab.components['profile-tab'].hideExpandedDescription();
                    }

                    self.collapse(activeCallback);

                    setTimeout(() => {
                        if (!isRightPanelInCenter()) {
                            const mainElementsMovingEl = document.querySelector('[main-elements-moving]');
                            if (mainElementsMovingEl && mainElementsMovingEl.components && mainElementsMovingEl.components['main-elements-moving']) {
                                const mainElementsMoving = mainElementsMovingEl.components['main-elements-moving'];
                                const originalCheck = mainElementsMoving.checkIfChartNotBlocked;
                                const originalLastClickTime = mainElementsMoving.lastClickTime;
                                mainElementsMoving.checkIfChartNotBlocked = () => false;
                                mainElementsMoving.lastClickTime = 0;
                                mainElementsMoving.handleClickOnArrow(false);
                                mainElementsMoving.checkIfChartNotBlocked = originalCheck;
                                mainElementsMoving.lastClickTime = originalLastClickTime;
                            }
                        }
                    }, 650);
                } else if (rightInCenter) {
                    const now = Date.now();
                    const timeSinceLastClick = now - self.lastArrowClickTime;
                    if (timeSinceLastClick < self.arrowClickThrottleTime) {
                        event.stopImmediatePropagation();
                        event.preventDefault();
                        return;
                    }
                    self.lastArrowClickTime = now;
                }
            }, true);
        }
    }
});
